import jsPDF from 'jspdf';
import type { MeasurementRecord } from './MeasurementNotebook';

export interface MeasurementReport {
  studentName: string;
  readings: MeasurementRecord[];
  conclusion: string;
}

export function generateMeasurementReport({ studentName, readings, conclusion }: MeasurementReport): Blob {
  const pdf = new jsPDF({ orientation: 'landscape' });
  const pageHeight = pdf.internal.pageSize.getHeight();
  let y = 18;
  const write = (text: string, size = 10) => {
    pdf.setFontSize(size);
    const lines = pdf.splitTextToSize(text, 265) as string[];
    if (y + lines.length * 6 > pageHeight - 15) { pdf.addPage(); y = 18; }
    pdf.text(lines, 14, y);
    y += lines.length * 6 + 2;
  };

  pdf.setTextColor(23, 65, 57);
  write('Measurement and Units Laboratory Report', 18);
  pdf.setTextColor(35, 45, 42);
  write(`Student: ${studentName || 'Student'}    Date: ${new Date().toLocaleDateString()}`);
  write('Aim: Use calibrated instruments to measure physical quantities, apply corrections, and report readings with uncertainty.');
  write(`Readings recorded: ${readings.length}`);
  y += 2;
  readings.forEach((reading, index) => {
    pdf.setFont('helvetica', 'bold');
    write(`${index + 1}. ${reading.quantity} using ${reading.instrumentName} (least count ${reading.leastCount} ${reading.unit})`);
    pdf.setFont('helvetica', 'normal');
    write(`Raw: ${reading.rawReading} ${reading.unit}; zero correction: ${reading.zeroCorrection} ${reading.unit}; corrected: ${reading.correctedReading} ± ${reading.uncertainty} ${reading.unit}; ${reading.significantFigures} significant figures.`);
    write(`Method note: ${reading.remarks || 'No additional remarks.'}`);
  });
  y += 2;
  pdf.setFont('helvetica', 'bold');
  write('Conclusion and discussion', 12);
  pdf.setFont('helvetica', 'normal');
  write(conclusion || 'No conclusion recorded.');
  const blob = pdf.output('blob');
  pdf.save('measurement-lab-report.pdf');
  return blob;
}
